import axios from "axios";

import APIRoutes from "../../APIRoutes";

import { getAPIRoot } from "../../../utils/GeneralUtils";

/**
 * postFacilityApproval
 *
 * Approve or deny the Facility for the id passed.
 *
 * @param auth_token The user's auth token, used for fetching data that requires certain privileges
 * @param id Facility id to approve or deny
 * @param message Message of deny modification details
 * @param approve Boolean indicating approval or deny
 * @returns True or Error if approved, True and message or Error if denied.
 */

export const postFacilityApproval = async (
  auth_token: string,
  id: string,
  message: string,
  approve: boolean
) => {
  try {
    const res = await axios.post(
      getAPIRoot(APIRoutes.post.approve_facility, "admin"),
      {
        sonic_id: id,
        sonic_message: message,
        sonic_approve: approve,
      },
      {
        headers: auth_token
          ? {
              "X-Sonic-Auth": auth_token,
            }
          : undefined,
      }
    );
    return res.data;
  } catch (e) {
    return null;
  }
};
